import { render } from "./CompletedCryptoNFRsV1.1.vue?vue&type=template&id=3dbcff9e"
import script from "./CompletedCryptoNFRsV1.1.vue?vue&type=script&lang=js"
export * from "./CompletedCryptoNFRsV1.1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__